import React from "react"

import clsxm from "@/lib/clsxm"
import type { Notices } from "@/lib/notices"

import Icon from "@/components/common/Icon/Icon"
import { noticeItemThemes } from "@/components/Notice/Item/themes"

import { CloseIcon } from "@/constants/icons"

export type NoticeItemComponentProps = {
  className?: React.HTMLAttributes<HTMLDivElement>[`className`]
  item: Notices.Item
  noticeFunctions: Notices.ContextFunctions
}

type State = Record<string, never>

export class NoticeItemComponent extends React.PureComponent<
  NoticeItemComponentProps,
  State
> {
  private onCloseClick = () => {
    this.props.noticeFunctions.removeNotice(this.props.item)
  }

  public render = () => {
    const theme = noticeItemThemes[this.props.item.type]

    return (
      <div
        className={clsxm(
          `flex items-center rounded-lg px-4 py-3`,
          theme.containerClassName,
          this.props.className
        )}
      >
        <Icon icon={theme.icon} />
        <p className={`ml-4 flex-1`}>{this.props.item.message}</p>
        <div className={`cursor-pointer`} onClick={this.onCloseClick}>
          <Icon icon={CloseIcon} size={`sm-20`} />
        </div>
      </div>
    )
  }
}
